export const scrollableOption = {
  duration: 800,
  delay: 100,
  smooth: true,
  offset: -50,
};
